import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useControlledRef } from '../../../../internal/hooks';
export function useCheckboxGroupOptions(props) {
  const {
    options
  } = props;
  const propsRef = useValueRef(props);
  const [valueRef, setValue] = useControlledRef({
    controlled: props.value,
    default: props.defaultValue || []
  });
  return React.useMemo(() => {
    return options.map(option => _objectSpread(_objectSpread({}, option), {}, {
      onChange: e => {
        const optionValue = option.value;
        const {
          onChange
        } = propsRef.current;
        if (!onChange) {
          return;
        }
        const prevValue = valueRef.current;
        const isChecked = prevValue.includes(optionValue);
        if (isChecked) {
          setValue(prevValue.filter(v => v !== optionValue));
        } else {
          setValue([...prevValue, optionValue]);
        }
        onChange(e, valueRef.current);
      }
    }));
  }, [options, propsRef, valueRef, setValue]);
}